module.exports = __webpack_public_path__ + "img/icon02.f4c3c1d.png";